<claas-icon-button
  data-testid="support-menu-button"
  tabindex="0"
  [class.hide-badge]="!showNewsBadge()"
  [iconBadge]="{
    id: 'helpBadge',
    badge: showNewsBadge(),
    badgeValue: null,
    customBadgeClasses: 'help-menu-badge-offset',
    badgeVariant: 'info',
    badgeIcon: null,
    badgeIconSize: 'medium-icon',
    badgeValueLimit: null,
  }"
  [matMenuTriggerFor]="supportFormMenu"
  [icon]="{ iconId: '648470', namespace: 'cc', iconStyle: 'bold' }"></claas-icon-button>

<mat-menu #supportFormMenu="matMenu" class="support-form-menu-container" xPosition="before" backdropClass="pc">
  <div data-testid="support-menu-panel">
    <button
      mat-menu-item
      (click)="onHelpCenterClick()"
      tabindex="1"
      class="support-form-menu-item mb-1"
      data-testid="help-center-button">
      <span class="flex items-center">
        <claas-icon [removeDefaultColor]="true" class="cc-apps mr-3" iconId="648470" namespace="cc" [size]="22">
        </claas-icon>
        {{ 'support.help-center' | translate }}
      </span>
      <claas-icon
        [removeDefaultColor]="true"
        class="open-in-new"
        iconId="659469"
        namespace="cc"
        [size]="16"></claas-icon>
    </button>
    <button
      mat-menu-item
      (click)="onNewsClick()"
      tabindex="1"
      class="support-form-menu-item mb-1"
      data-testid="news-link-button">
      <span class="flex items-center">
        <claas-icon
          badgeVariant="info"
          [badge]="showNewsBadge()"
          [class.hide-badge]="!showNewsBadge()"
          [removeDefaultColor]="true"
          class="cc-apps mr-3"
          iconId="659500"
          namespace="cc"
          [size]="22">
        </claas-icon>
        {{ 'support.news-link-button' | translate }}
      </span>
      <claas-icon
        [removeDefaultColor]="true"
        class="open-in-new"
        iconId="659469"
        namespace="cc"
        [size]="16"></claas-icon>
    </button>

    <span class="block my-1"><mat-divider></mat-divider></span>

    <button
      mat-menu-item
      (click)="onSupportFormClick()"
      tabindex="2"
      class="support-form-menu-item mt-1"
      data-testid="support-form-button">
      <span class="flex items-center">
        <claas-icon [removeDefaultColor]="true" class="cc-apps mr-3" iconId="750380" namespace="cc" [size]="22">
        </claas-icon>
        {{ 'support.support-contact-form' | translate }}
      </span>
    </button>

    <button
      mat-menu-item
      (click)="onInviteTempSupportClick()"
      tabindex="3"
      class="support-form-menu-item mt-1"
      data-testid="invite-support-button">
      <span class="flex items-center">
        <claas-icon [removeDefaultColor]="true" class="cc-apps mr-3" iconId="795311" namespace="cc" [size]="22">
        </claas-icon>
        {{ 'support.support_invite' | translate }}
      </span>
      <claas-icon
        [removeDefaultColor]="true"
        class="open-in-new"
        iconId="659469"
        namespace="cc"
        [size]="16"></claas-icon>
    </button>
  </div>
</mat-menu>
